<template>
	<OaoFormInput
		v-model="innerValue"
		:label="label"
		:name="name"
		:validationId="validationId"
		:type="type"
		:placeholder="placeholder"
		:disabled="disabled"
		:dateConfig="dateConfig"
		:validationRules="validationRules"
		:isOptional="isOptional"
		:disableAutocomplete="disableAutocomplete"
		:isSmall="isSmall"
		@change="$emit('change', $event)"
		:id="id"
		:tooltip="tooltip"
		:tooltipTypeId="tooltipTypeId"
		:hideLabel="hideLabel"
		:sublabel="parsedSublabel"
		:sublabelWarning="isOverMaxMonthlyIncome"
	/>
</template>

<script>
	import { ValidationProvider } from 'vee-validate';

	import { OaoFormInput } from '@/components';

	export default {
		name: 'FormIncomeInput',
		components: {
			ValidationProvider,
			OaoFormInput
		},
		props: {
			value: {
				required: true
			},
			label: {
				type: String,
				required: true
			},
			name: {
				type: String,
				required: false
			},
			type: {
				type: String,
				required: false,
				default: 'text'
			},
			placeholder: {
				type: String,
				required: false
			},
			disabled: {
				type: Boolean,
				required: false
			},
			validationRules: {
				type: [String, Object],
				required: false
			},
			dateConfig: {
				type: Object,
				required: false
			},
			mask: {
				type: [String, Array],
				required: false
			},
			maskOutput: {
				type: Boolean,
				required: false
			},
			isOptional: {
				type: Boolean,
				required: false
			},
			disableAutocomplete: {
				type: Boolean,
				required: false
			},
			validationId: {
				type: String,
				required: false
			},
			isSmall: {
				type: Boolean,
				required: false,
				default: false
			},
			id: {
				type: [String, Number],
				required: false
			},
			tooltip: {
				type: Boolean,
				required: false
			},
			tooltipTypeId: {
				type: Number,
				required: false
			},
			hideLabel: {
				type: Boolean,
				required: false
			},
			maxMonthlyIncome: {
				type: Number,
				required: false
			},
			sublabelTemplate: {
				type: String,
				required: false
			}
		},
		computed: {
			innerValue: {
				get() {
					if (this.value === null || this.value === undefined || this.value === '') {
						return '';
					}
					const num = Number(this.value);
					if (isNaN(num)) {
						return '';
					}
					// Format with thousands separators and leading dollar sign
					return '$' + num.toLocaleString('en-US');
				},
				set(val) {
					// Strip all non-digit characters
					const digits = (val || '').replace(/\D/g, '');
					const num = digits ? Number(digits) : null;
					this.$emit('input', num);
				}
			},
			isOverMaxMonthlyIncome() {
				if (!this.value || !this.maxMonthlyIncome) {
					return false;
				}

				return this.value >= this.maxMonthlyIncome;
			},
			parsedSublabel() {
				if (!this.value) {
					return;
				}

				let parsedString = this.sublabelTemplate.replaceAll(
					'{0}',
					'$' + Number(this.annualIncome).toLocaleString('en-US')
				);

				return parsedString;
			},
			annualIncome() {
				if (this.value) {
					return this.value * 12;
				} else {
					return 0;
				}
			}
		}
	};
</script>
